<template>
    <div>
        <table class="table table-responsive-md border border-gray overflow-auto">
            <thead>
                <tr class="bg-table-header">
                    <th>Billable</th>
                    <th>Payer</th>
                    <th>Start Date</th>
                    <th>Start Time</th>
                    <th>End Date</th>
                    <th>End Time</th>
                    <th>Billed</th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <tbody>
                <TableEmpty
                    v-if="detail.length == 0 && newDetail.length == 0"
                    :col-span="columns"
                    :component="diagnoses"
                    secondary-message="No Payroll Detail Found"
                />
            </tbody>
            <tbody>
                <MidnightSplitRow
                    v-for="detail of taskShifts"
                    :detail="detail"
                    :id="id"
                    :snapshot-view="snapshotView"
                />
            </tbody>
            <tbody>
                <MidnightSplitRow
                    v-for="detail of newDetail"
                    :detail="detail"
                    :is-add-requested="true"
                    :save-new-detail="saveNewDetail"
                    v-if="newDetail.length > 0"
                    :cancel-save-new-detail="cancelSaveNewDetail"
                    :is-new-terminal="isNewTerminal"
                    :snapshot-view="snapshotView"
                />
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" src="./MidnightSplitTable.ts"></script>
